// Every angle is summarized rather than only the one an inspection declared,
// because the ledger pools samples across inspections that were specified
// differently. A sample carries a reading at all three regardless.
export const METRICS = [
  { key: "gloss20", label: "Gloss 20°" },
  { key: "gloss60", label: "Gloss 60°" },
  { key: "gloss85", label: "Gloss 85°" },
  { key: "doi", label: "DOI" },
  { key: "haze", label: "Haze (%)" },
  { key: "ra", label: "Ra (μm)" },
];

export const SAMPLE_STATES = {
  ACTIVE: "active",
  DELETED: "deleted",
  HIDDEN_PARENT: "hiddenParent",
  ORPHANED: "orphaned",
};

// Named in words rather than by color alone, so the state survives printing,
// screen readers and color vision deficiency.
export const STATE_LABELS = {
  [SAMPLE_STATES.ACTIVE]: "Active",
  [SAMPLE_STATES.DELETED]: "Deleted",
  [SAMPLE_STATES.HIDDEN_PARENT]: "Inspection hidden",
  [SAMPLE_STATES.ORPHANED]: "Orphaned",
};

export const formatStatistic = (value) => {
  if (typeof value !== "number" || !Number.isFinite(value)) return "—";

  return value.toFixed(2);
};

export const formatMeasurement = (value) => {
  if (typeof value !== "number" || !Number.isFinite(value)) return "—";

  return value.toFixed(2);
};

export const formatCount = (value) => (value ?? 0).toLocaleString();

/**
 * The range a report actually covered, as the dates a person picked.
 *
 * Formatted in UTC because the bounds are sent as plain midnight and land in
 * the response as UTC instants; rendering them in the viewer's zone would show
 * a report run for the 1st as starting on the 31st. The upper bound is
 * exclusive, so a millisecond comes off it to name the last day included.
 *
 * @param {{start: string, end: string}} range
 * @return {string}
 */
export const formatDateRange = (range) => {
  if (!range?.start || !range?.end) return "—";

  const options = {
    timeZone: "UTC",
    year: "numeric",
    month: "short",
    day: "numeric",
  };

  const start = new Date(range.start);
  const lastIncludedDay = new Date(new Date(range.end).getTime() - 1);

  if (Number.isNaN(start.getTime()) || Number.isNaN(lastIncludedDay.getTime())) {
    return "—";
  }

  return (
    `${start.toLocaleDateString("default", options)} – ` +
    `${lastIncludedDay.toLocaleDateString("default", options)}`
  );
};

export const formatTimestamp = (isoString) => {
  if (!isoString) return "—";

  const date = new Date(isoString);

  if (Number.isNaN(date.getTime())) return "—";

  return date.toLocaleString("default", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};
